import Button from '../Button'

export interface EmailProps {
  value: string
  text?: string
  minimal?: boolean
  className?: string
  iconStart?: React.ElementType
  style?: React.CSSProperties
}

const Email = ({ value, text, className, style, ...restProps }: EmailProps) => (
  <Button data-qa='email' minimal element='a' href={`mailto:${value}`} className={className} style={style} {...restProps}>
    {text || value}
  </Button>
)

export default Email
